module.exports = __webpack_public_path__ + "static/media/shop-gold-cap.8665d105.png";